import Footer from '../../components/Footer'
import MainHeader from '../../components/MainHeader'
import Services from '../../components/Services'
import UseCases from '../../components/UseCases'
import AboutUs from '../../components/AboutUs'
import ContactUs from '../../components/ContactUs'

import './home.css'

const Home = () => {
  return (
    <>
    <MainHeader/>
    <Services/>
    <UseCases/>
    <AboutUs/>
    <ContactUs/>
    <Footer/>
    </>
  )
}

export default Home